import React from 'react';
import { ArrowUpTrayIcon, ChartBarIcon, DocumentTextIcon, CheckBadgeIcon } from '@heroicons/react/24/outline';
import { Container } from '../common/Container';

const steps = [
  {
    number: '01',
    title: 'Upload Property Data',
    description: 'Import your property lists via CSV or connect directly to county assessor databases.',
    Icon: ArrowUpTrayIcon
  },
  {
    number: '02',
    title: 'Automated Analysis',
    description: 'Our system analyzes properties using cost approach, income approach, and equity comparables.',
    Icon: ChartBarIcon
  },
  {
    number: '03',
    title: 'Generate Reports',
    description: 'Create comprehensive valuation workups with all documentation needed for appeals.',
    Icon: DocumentTextIcon
  },
  {
    number: '04',
    title: 'Track & Win',
    description: 'Manage appeals through every stage from notice to litigation with full workflow tracking.',
    Icon: CheckBadgeIcon
  }
];

export const HowItWorks: React.FC = () => {
  return (
    <section id="how-it-works" className="py-24 bg-brand-blue-50">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-brand-blue mb-4">
            How It Works
          </h2>
          <p className="text-xl text-brand-white-600 max-w-3xl mx-auto">
            From data to decision in four simple steps
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line (desktop only) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-[calc(50%+2rem)] w-[calc(100%-4rem)] h-0.5 bg-brand-blue-200 z-0" />
              )}
              
              <div className="relative z-10">
                {/* Number Badge */}
                <div className="w-32 h-32 mx-auto bg-white rounded-full shadow-lg flex items-center justify-center mb-6">
                  <span className="text-5xl font-bold text-brand-red">
                    {step.number}
                  </span>
                </div>
                
                <div className="text-center">
                  <step.Icon className="w-10 h-10 text-brand-blue mx-auto mb-4" />
                  
                  <h3 className="text-xl font-bold text-brand-blue mb-3">
                    {step.title}
                  </h3>
                  
                  <p className="text-brand-white-600">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

